import { render, staticRenderFns } from "./walkingLantern.vue?vue&type=template&id=cad930ba&scoped=true"
import script from "./walkingLantern.vue?vue&type=script&lang=js"
export * from "./walkingLantern.vue?vue&type=script&lang=js"
import style0 from "./walkingLantern.vue?vue&type=style&index=0&id=cad930ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cad930ba",
  null
  
)

export default component.exports